import { useState } from 'react';
import { t } from 'services/translation';
import { JoinWaitlistModal } from './JoinWaitlistModal';
import { WaitlistSuccessModal } from './SuccessModal';
import {
  Container,
  Text,
  NoAvailability,
  LinkText,
  WaitlistText,
} from './styles';

type JoinWaitlistProps = {
  experienceId: number;
  noAvailability: boolean;
  userId: number;
  soldOutLinkText: string;
  brandColor: string;
  isoTime: boolean;
};

export const JoinWaitlist = ({
  experienceId,
  noAvailability,
  userId,
  soldOutLinkText,
  brandColor,
  isoTime,
}: JoinWaitlistProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);

  const handleSuccessModal = () => {
    setSuccessModal(true);
  };

  return (
    <Container>
      <WaitlistSuccessModal
        isOpen={successModal}
        onClose={() => setSuccessModal(false)}
      />
      <JoinWaitlistModal
        experienceId={experienceId}
        isOpen={open}
        onClose={() => setOpen(false)}
        showSuccessModal={() => handleSuccessModal()}
        userId={userId}
        brandColor={brandColor}
        isoTime={isoTime}
      />
      <div>
        {noAvailability ? (
          <NoAvailability>
            <Text>{t('SORRY_WE_CURRENTLY_DO_NOT_HAVE_ANY_AVAILABILITY')}</Text>
            <LinkText
              className="brand-color"
              fontSize="18px"
              onClick={() => setOpen(true)}
            >
              {soldOutLinkText || t('JOIN_THE_WAITLIST')}
            </LinkText>
          </NoAvailability>
        ) : (
          <WaitlistText data-testid="join-waitlist-msg">
            {t('IF_YOUR_PREFERRED_DATE_AND_TIME_IS_UNAVAILABLE')}
            <LinkText className="brand-color" onClick={() => setOpen(true)}>
              {t('JOIN_THE_WAITLIST').toLowerCase()}
            </LinkText>
            .
          </WaitlistText>
        )}
      </div>
    </Container>
  );
};
